import { Toaster as SonnerToaster, toast } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      duration={5000}
      visibleToasts={3}
      theme="dark"
      toastOptions={{
        style: {
          background: 'var(--bg-elevated)',
          border: '1px solid var(--border-color)',
          borderRadius: '10px',
          color: 'var(--text-primary)',
          fontFamily: 'Inter, sans-serif',
          fontSize: '13px',
        },
      }}
    />
  );
}

export { toast };
